import React from 'react';
export const NoData = ({ msg }) => {
    return (
        <div className="row">
            <div className="col-12">
                <h5 className="title">{msg}</h5>
            </div>
        </div>
    )
}